const aws = require("aws-sdk");
const axios = require("axios");

aws.config.update({
  secretAccessKey: process.env.VUE_APP_AWS_SECRET_ACCESS_KEY,
  accessKeyId: process.env.VUE_APP_AWS_ACCESS_KEY,
});

export const s3 = new aws.S3({
  signatureVersion: "v4",
  region: process.env.VUE_APP_AWS_REGION,
});


export const riskUpload = (file, folder)=> {
   const key = folder + "/" + file.name.replace(/\s/g, "-");
  const params = {
    Bucket: process.env.VUE_APP_AWS_BUCKET_WMS,
    Key: key,
    Expires: 30,
    ContentType: file.type,
  };
  const url = s3.getSignedUrl("putObject", params);
  return axios.put(url, file, {
    headers:{
      "Content-Type": file.type,
    }
  })
  .then((result) => {
    const bucketUrl = decodeURIComponent(result.request.responseURL).split(
      key
    )[0];
    result.key = key;
    result.fullPath = bucketUrl + key;
    return result;
  })
  .catch((err) =>{
    return err;
  });

};

export const riskDirectDownloadByKey = (key) => {
  const url = s3.getSignedUrl("getObject", {
    Bucket: process.env.VUE_APP_AWS_BUCKET_WMS,
    Key: key,
    Expires: 60,
  });
  return url;
};




export const singleUpload = (file, folder) => {
  const key = folder + "/" + file.name.replace(/\s/g, "-");
  const params = {
    Bucket: process.env.VUE_APP_AWS_BUCKET,
    Key: key,
    Expires: 10,
    ContentType: file.type,
  };
  const url = s3.getSignedUrl("putObject", params);
  return axios

    .put(url, file, {
      headers: {
        "Content-Type": file.type,
      },
    })
    .then((result) => {
      const bucketUrl = decodeURIComponent(result.request.responseURL).split(
        key
      )[0];
      result.key = key;
      result.fullPath = bucketUrl + key;
      return result;
    })
    .catch((err) => {
      // TODO: error handling
      return err;
    });
};

export const deleteObjectByKey = (key) => {
  const params = {
    Bucket: process.env.VUE_APP_AWS_BUCKET,
    Key: key,
  };
  const data = s3.deleteObject(params).promise();

  return data;
};

export const directDownloadByKey = (key) => {
  const url = s3.getSignedUrl("getObject", {
    Bucket: process.env.VUE_APP_AWS_BUCKET,
    Key: key,
    Expires: 60,
  });
  return url;
};
